import { Link } from "react-router-dom";
import type { DailyCheckIn } from "../types";
import { getImpactText } from "../utils";

interface CheckInReflectionProps {
	checkIn: DailyCheckIn;
	isMobile?: boolean;
}

export const CheckInReflection = ({
	checkIn,
	isMobile = false,
}: CheckInReflectionProps) => {
	if (checkIn.reflection) {
		return (
			<div className="space-y-2 pt-2 border-t border-border sm:pt-0 sm:border-t-0">
				<Link
					to={`/reflection/${checkIn.reflection.id}`}
					className="text-primary hover:text-primary/80 transition-colors"
				>
					<span className="text-xs font-medium">
						{checkIn.reflection.title}
					</span>
				</Link>

				{checkIn.reflection_feeling !== null &&
					checkIn.reflection_feeling !== undefined && (
						<div className="flex items-center space-x-2">
							<span className="text-xs text-muted-foreground">
								{isMobile ? "Feeling:" : "Level:"}
							</span>
							<span className="text-xs font-medium">
								{isMobile ? (
									<>
										{checkIn.reflection_feeling > 0 ? "+" : ""}
										{checkIn.reflection_feeling}
										{checkIn.reflection_feeling > 0
											? " (Better)"
											: checkIn.reflection_feeling < 0
												? " (Worse)"
												: " (Same)"}
									</>
								) : (
									getImpactText(checkIn.reflection_feeling)
								)}
							</span>
						</div>
					)}

				{checkIn.reflection?.description && (
					<p className="text-xs text-muted-foreground line-clamp-2">
						{checkIn.reflection.description}
					</p>
				)}
			</div>
		);
	}

	// Show inline reflection details if user entered reflection data on the check-in
	if (
		checkIn.reflection_impact ||
		checkIn.reflection_feeling !== null ||
		checkIn.reflection_reasons
	) {
		return (
			<div className="space-y-2 pt-2 border-t border-border sm:pt-0 sm:border-t-0">
				<div className="flex items-center space-x-2 text-foreground">
					<span className="text-sm font-medium">Reflection (check-in)</span>
				</div>

				{typeof checkIn.reflection_feeling !== "undefined" &&
					checkIn.reflection_feeling !== null && (
						<div className="flex items-center space-x-2">
							<span className="text-xs text-muted-foreground">Level:</span>
							<span className="text-xs font-medium">
								{getImpactText(checkIn.reflection_feeling)}
							</span>
						</div>
					)}

				{checkIn.reflection_reasons && (
					<p className="text-xs text-muted-foreground line-clamp-2">
						{checkIn.reflection_reasons}
					</p>
				)}
			</div>
		);
	}

	return (
		<span className="text-xs text-muted-foreground">
			No reflection check-in
		</span>
	);
};
